module.exports = __webpack_public_path__ + "img/bottom.b27ae99f.png";